<template>
  <a-row :gutter="20" class="dashboard">
    <a-col :span="isDesktop ? 12 : 24">
      <a-alert v-if="user.needToPay" :message="$t('page.updateBilling.para1')" banner style="margin-bottom: 10px;" />
      <a-card :title="$t('cardTitle.updateBillingInfo')" class="style3 updateBillingInfo">
        <a-form :form="form" :layout="'vertical'" @submit="handleSubmit" id="billingInfo">
          <a-form-item :label="$t('label.firstNameFirstHalfChurchName')">
            <a-input data-recurly="first_name" v-decorator="['first_name', { rules: [{ required: true, message: $t('placeholder.pleaseInputFirstName') }] }]" />
          </a-form-item>
          <a-form-item :label="$t('label.lastNameSecondHalfChurchName')">
            <a-input data-recurly="last_name" v-decorator="['last_name', { rules: [{ required: true, message: $t('placeholder.pleaseInputLastName') }] }]" />
          </a-form-item>
          <a-form-item :label="$t('label.cardNumber')">
            <a-input @keypress.native="isNumber($event)" data-recurly="number" v-decorator="['number', { rules: [{ required: true, message: $t('placeholder.pleaseInputCardNumber') }] }]" />
          </a-form-item>
          <a-form-item :label="$t('label.expirationDate')" style="margin: 0;">
            <a-form-item :style="{ display: 'inline-block', width: '150px' }">
              <a-input @keypress.native="isNumber($event)" :maxLength="2" data-recurly="month" v-decorator="['month', { rules: [{ required: true, message: $t('placeholder.pleaseInputMonth') }] }]" />
            </a-form-item>
            <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">/</span>
            <a-form-item :style="{ display: 'inline-block', width: '150px' }">
              <a-input @keypress.native="isNumber($event)" :maxLength="2" data-recurly="year" v-decorator="['year', { rules: [{ required: true, message: $t('placeholder.pleaseInputYear') }] }]" />
            </a-form-item>
          </a-form-item>
          <a-form-item :label="$t('label.CVV')" :style="{ width: '150px' }">
            <a-input @keypress.native="isNumber($event)" data-recurly="cvv" :maxLength="3" v-decorator="['cvv', { rules: [{ required: true, message: $t('placeholder.pleaseInputCVV') }] }]" />
          </a-form-item>
          <input type="hidden" data-recurly="token" name="recurly_code" id="recurlyCode" />
          <a-form-item :wrapper-col="{ span: 12, offset: 0 }">
            <a-button type="primary" html-type="submit" :loading="isLoading">{{ $t('button.updateProfile') }}</a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import { mapState } from 'vuex';
import UserService from '@/services/UserService';
import initRecurly from '@/services/Recurly';
import { get, isEmpty } from 'lodash';
export default {
  data: () => ({
    isLoading: false,
  }),
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'billingInfo' });
  },
  computed: {
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  async mounted() {
    await initRecurly();
  },
  methods: {
    checkoutRecurly() {
      return new Promise((resolve, reject) => {
        recurly.token(document.getElementById('billingInfo'), err => {
          if (!isEmpty(err)) {
            reject(err);
          } else {
            resolve();
          }
        });
      });
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            await this.checkoutRecurly();
            await UserService.doUpdateBillingInfo(document.getElementById('recurlyCode').value);
            this.$notification['success']({
              message: 'Update successful.',
              description: `Credit Card Saved`,
            });
          } catch (error) {
            console.log(error);
            this.$notification['error']({
              message: error.response.status,
              description: get(error, 'response.data.error', error.message),
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>
